<template>
  <div class="app">
    <h1>热门服务</h1>
    <Header :activeIndex="'2'" />


    <!-- 这是热门服务 -->
    <nav class="tiaozhuan" aria-label="面包屑导航"><router-link to="/" style="cursor: pointer; color: inherit; text-decoration: none;">首页</router-link><span>&nbsp;&gt;&gt;&nbsp;</span><span>热门服务</span></nav>


    <div class="margintop">热门服务</div>
    <main v-if="!isMobile" style="margin-left: auto;margin-right: auto;">
      <el-row>
        <el-col :span="3">
          <div class="grid-content bg-purple-light">有限公司注册</div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple-light">个体工商户注册</div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple-light">外资公司注册</div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple-light">刻章</div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple-light">银行开户</div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="3">
          <div class="grid-content bg-purple">小规模代理记账</div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple">一般纳税人代理记账</div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple">外资代理记账</div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple">高新代理记账</div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple">税务报到</div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="3">
          <div class="grid-content bg-purple-light">汇算清缴</div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple-light">出口退税</div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple-light">社保开户</div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple-light">社保增员、减员</div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple-light">社保扣费</div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="3">
          <div class="grid-content bg-purple">社保基数核定</div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple">异地就医备案</div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple">退休代办</div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple">公积金开户</div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple">公积金增员、减员</div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="3">
          <div class="grid-content bg-purple-light">税控托管</div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple-light">发票托管</div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple-light">审计报告咨询</div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple-light">解除地址异常</div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple-light">解除税务异常</div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="3">
          <div class="grid-content bg-purple">发票增量</div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple">统计数据申报</div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple">电信增值业务许可</div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple">演出经纪许可</div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple">餐饮食品许可</div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="3">
          <div class="grid-content bg-purple-light">图书批发、零售许可</div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple-light">医疗器械许可</div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple-light">道路运输许可</div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple-light">进出口权许可</div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple-light">体系认证</div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="3">
          <div class="grid-content bg-purple">名称变更</div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple">经营范围变更</div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple">股东股权变更</div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple">法人变更</div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple">注册地址变更</div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="3">
          <div class="grid-content bg-purple-light">提供注册地址</div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple-light">增资减资</div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple-light">公司注销</div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple-light">工商注销</div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple-light">对公账户注销</div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="3">
          <div class="grid-content bg-purple">社保注销</div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple">公积金注销</div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple">商标注册、变更</div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple">软件著作权申请</div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple">高新申请</div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="3">
          <div class="grid-content bg-purple-light">工作流管理系统</div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple-light">CRM管理系统</div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple-light">企业信息库</div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple-light">出版大师</div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple-light">定制开发</div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="3">
          <div class="grid-content bg-purple">小程序建设</div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple">系统建设与搭建</div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple">招聘制度</div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple">薪酬制度</div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple">管理制度</div>
        </el-col>
        
      </el-row>
      <el-row>
        <el-col :span="3">
          <div class="grid-content bg-purple-light">财务制度</div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple-light">组织架构优化</div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple-light">运营流程优化</div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple-light">驻场诊断</div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple-light">培训体系建设</div>
        </el-col>
      </el-row>
    </main>
    <main v-else style="margin-left: auto;margin-right: auto;">
      <el-row>
        <el-col :span="3">
          <div class="grid-content bg-purple-light">有限公司<br>注册</div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple-light">个体工商户<br>注册</div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple-light">外资公司<br>注册</div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple-light">刻章</div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple-light">银行开户</div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="3">
          <div class="grid-content bg-purple">小规模<br>代理记账</div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple">一般纳税人<br>代理记账</div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple">外资<br>代理记账</div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple">高新<br>代理记账</div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple">税务报到</div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="3">
          <div class="grid-content bg-purple-light">汇算清缴</div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple-light">出口退税</div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple-light">社保开户</div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple-light">社保<br>增员、减员</div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple-light">社保扣费</div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="3">
          <div class="grid-content bg-purple">社保基数<br>核定</div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple">异地就医<br>备案</div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple">退休代办</div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple">公积金开户</div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple">公积金<br>增员、减员</div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="3">
          <div class="grid-content bg-purple-light">税控托管</div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple-light">发票托管</div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple-light">审计报告<br>咨询</div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple-light">解除<br>地址异常</div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple-light">解除<br>税务异常</div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="3">
          <div class="grid-content bg-purple">发票增量</div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple">统计数据<br>申报</div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple">电信增值<br>业务许可</div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple">演出经纪<br>许可</div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple">餐饮食品<br>许可</div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="3">
          <div class="grid-content bg-purple-light">图书批发、<br>零售许可</div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple-light">医疗器械<br>许可</div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple-light">道路运输<br>许可</div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple-light">进出口权<br>许可</div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple-light">体系认证</div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="3">
          <div class="grid-content bg-purple">名称变更</div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple">经营范围<br>变更</div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple">股东股权<br>变更</div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple">法人变更</div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple">注册地址<br>变更</div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="3">
          <div class="grid-content bg-purple-light">提供<br>注册地址</div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple-light">增资减资</div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple-light">公司注销</div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple-light">工商注销</div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple-light">对公账户<br>注销</div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="3">
          <div class="grid-content bg-purple">社保注销</div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple">公积金注销</div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple">商标注册、<br>变更</div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple">软件著作权<br>申请</div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple">高新申请</div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="3">
          <div class="grid-content bg-purple-light">工作流<br>管理系统</div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple-light">CRM<br>管理系统</div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple-light">企业信息库</div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple-light">出版大师</div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple-light">定制开发</div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="3">
          <div class="grid-content bg-purple">小程序建设</div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple">系统设计<br>与搭建</div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple">招聘制度</div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple">薪酬制度</div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple">管理制度</div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="3">
          <div class="grid-content bg-purple-light">财务制度</div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple-light">组织<br>架构优化</div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple-light">运营<br>流程优化</div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple-light">驻场诊断</div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple-light">培训<br>体系建设</div>
        </el-col>
      </el-row>
    </main>
    <Youshi />
    <Footer />
  </div>
</template>


<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import Youshi from '@/components/Youshi.vue'

export default {
  name: 'remen',
  components: {
    Header,
    Footer,
    Youshi
  },
  data() {
    return {
      activeIndex: '2',
      imgCount: 0,
      currentIndex: 0,
      intervalID: '',
      pppclose: true,
      isMobile: true
    }
  },
  mounted() {
    window.scrollTo(0, 0);
    // console.log(this.$root.showData.showData);
    this.$root.showData.showData = false;
    this.checkScreenSize(); // 初始化时检查屏幕大小
    window.addEventListener('resize', this.checkScreenSize); // 监听窗口大小变化
  },
  beforeDestroy() {
    // 移除全局点击事件监听
    window.removeEventListener('resize', this.checkScreenSize);
  },
  methods: {
    checkScreenSize() {
      this.isMobile = window.innerWidth <= 768; // 根据屏幕宽度判断是否是移动端
    },
    pppopco() {
      this.$root.ppp.ppp = !this.$root.ppp.ppp
    },
    pathIndex() {
      this.$router.push('/');
    },
    pathRemen() {
      this.$router.push('/remen')
    },
    pathJizhang() {
      this.$router.push('/jizhang');
    },
    pathgongshang() {
      this.$router.push('/gongshang')
    },
    pathshuiwu() {
      this.$router.push('/shuiwu');
    },
    pathzhichan() {
      this.$router.push('/zhichan')
    },
    pathxuke() {
      this.$router.push('/xuke')
    },
    pathrenshi() {
      this.$router.push('/renshi')
    },
    pathxueyuan() {
      this.$router.push('/xueyuan');
    },
    pathxinxi() {
      this.$router.push('/xinxi')
    },
    pathcontact() {
      this.$router.push('/contact')
    },
    pathCompanyReg() {
      this.$router.push('/zhuce')
    },
  }
}
</script>

<style>
.el-menu.el-menu--horizontal {
  border-bottom: none !important;
}

.el-carousel__button {
  background-color: #000 !important;
}

.el-menu-item.is-active {
  background-color: #b30101 !important;
}

.el-menu--horizontal>.el-menu-item {
  float: left;
  height: 45px !important;
  line-height: 45px !important;
  margin: 0;
}

@media (max-width: 768px) {

  .el-menu--horizontal>.el-menu-item {
    float: left;
    height: 30px !important;
    line-height: 30px !important;
    margin: 0;
  }

  .responsive-carousel el-carousel el-carousel--horizontal {
    height: 128px !important;
  }

  .el-carousel__indicators el-carousel__indicators--horizontal {
    margin-top: 15px !important
  }

  .el-pager li {
    padding: 0 0px !important;
    min-width: 25.5px !important;
  }
}
</style>

<style scoped>
/* 热门服务 */
.el-row {
  margin-bottom: 14px;

  &:last-child {
    margin-bottom: 0;
  }

  display: flex;
  justify-content: center;

}

.el-col {
  border-radius: 4px;
}

/* .bg-purple-dark {
  background: #99a9bf;
} */

.bg-purple {
  background: #037dfb91;
  color: #fffb00;
}

.bg-purple-light {
  background: #fddbdb;
}

.grid-content {
  border-radius: 4px;
  min-height: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 10px;
}

.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}


/* 其他 */
ul,
li {
  margin: 0;
  padding: 0;

}

h1 {
  font-size: 0%;
}

.margintop {
  margin-left: auto;
  margin-right: auto;
  /* margin-top: 118px; */
  font-size: 25px;
  margin-bottom: 11px;
  font-weight: 700;
  font-family:Impact, Haettenschweiler, 'Arial Narrow Bold', sans-serif;
  /* font-family: 'msyh', sans-serif; */
}

.tiaozhuan {
  text-align: left;
  margin-bottom: 0.83em;
  margin-top: 118px;
  margin-left: 19.5%;
  font-size:18px;
  font-weight: 500;
}


@media (max-width: 768px) {
  .el-row {
    margin-bottom: 8px;

    &:last-child {
      margin-bottom: 0;
    }

    display: flex;
    justify-content: center;

  }


  /* 其他 */

  .el-col-6 {
    width: 50% !important;
  }

  .margintop {
    margin-left: auto;
    margin-right: auto;
    /* margin-top: 95px; */
    margin-bottom: 5px;
    font-size: 15px;
  }

  .tiaozhuan {
    text-align: left;
    margin-bottom: 0.83em;
    margin-top: 100px;
    margin-left: 2%;
    font-size:11px;
  }

  .grid-content {
    border-radius: 4px;
    min-height: 36px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 2px;
    margin-right: 2px;
    font-size: 12px;
  }

  .row-bg {
    padding: 7px 0;
    background-color: #f9fafc;
  }

  .el-col-3 {
    width: 19.5%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/remen.vue